module.exports = __webpack_public_path__ + "static/media/build07.28a75446.jpg";